import axios from '@/framework/http/axios'
const model = 'school'

let findByUserUrl = `api/${model}/findByUser`
let findWithMeUrl = `api/${model}/findWithMe`
let businessInformationUrl = `api/${model}/businessInformation`

export function findByUser(param, callback) {
  axios.post(findByUserUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}
export function findSchool(param, callback) {
  axios.post(findWithMeUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}

export function businessInformation(param, callback) {
  axios.post(businessInformationUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}



// WEBPACK FOOTER //
// ./src/project/service/school.js